module.exports = __webpack_public_path__ + "static/media/Car-icon.84201048.svg";